export enum ScoringTypes {
  PPR = 'PPR',
  HALF_PPR = 'HALF PPR',
  NON_PPR = 'NON-PPR',
}
